import { useCallback, useMemo } from "react";
import {
  type CarSearchComponentProps,
  useCarSearch as useCoreCarSearch,
} from "@b2bportal/core-cars";

export const useCarSearch = (props: CarSearchComponentProps) => {
  const { context, handlers } = useCoreCarSearch(props);

  const { setFormError } = handlers;

  const handlePickupLocationFocus = useCallback(() => {
    setFormError((prev) => ({ ...prev, pickupLocation: undefined }));
  }, [setFormError]);

  const handleDropoffLocationFocus = useCallback(() => {
    setFormError((prev) => ({ ...prev, dropoffLocation: undefined }));
  }, [setFormError]);

  return useMemo(
    () => ({
      context,
      handlers: {
        ...handlers,
        handlePickupLocationFocus,
        handleDropoffLocationFocus,
      },
    }),
    [context, handlers, handlePickupLocationFocus, handleDropoffLocationFocus]
  );
};
